import React from 'react';
import '../../styles/app-download.css';

/**
 * Los dos botones de tienda. Único lugar donde viven las URLs y los
 * logotipos, para que el Home y la página de Contacto no se desincronicen.
 *
 * Las dos fichas ya están publicadas y son gratuitas en la tienda de México:
 * App Store id 6762004834 e ID de Google Play com.soempg.app.
 */
export const IOS_URL = 'https://apps.apple.com/mx/app/soem-pg/id6762004834';
export const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.soempg.app';

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M17.05 12.54c-.03-2.6 2.12-3.85 2.22-3.91-1.21-1.77-3.09-2.01-3.76-2.04-1.6-.16-3.12.94-3.93.94-.81 0-2.06-.92-3.39-.9-1.74.03-3.35 1.01-4.25 2.57-1.81 3.14-.46 7.79 1.3 10.34.86 1.25 1.89 2.65 3.23 2.6 1.3-.05 1.79-.84 3.36-.84 1.57 0 2.01.84 3.38.81 1.4-.02 2.28-1.27 3.13-2.53.99-1.45 1.4-2.86 1.42-2.93-.03-.01-2.72-1.04-2.75-4.13zM14.5 4.76c.71-.86 1.19-2.06 1.06-3.26-1.02.04-2.26.68-3 1.54-.66.76-1.24 1.98-1.08 3.15 1.14.09 2.3-.58 3.02-1.43z" />
  </svg>
);

const AndroidIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M17.6 9.48l1.84-3.18a.38.38 0 0 0-.14-.52.38.38 0 0 0-.52.14l-1.87 3.23a11.4 11.4 0 0 0-9.82 0L5.22 5.92a.38.38 0 0 0-.52-.14.38.38 0 0 0-.14.52L6.4 9.48A10.8 10.8 0 0 0 1 18h22a10.8 10.8 0 0 0-5.4-8.52zM7 15.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm10 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z" />
  </svg>
);

const StoreButtons = ({ className = '' }) => (
  <div className={`app-download-buttons ${className}`.trim()}>
    <a href={IOS_URL} className="store-btn" target="_blank" rel="noopener noreferrer">
      <span className="store-btn-icon"><AppleIcon /></span>
      <span className="store-btn-text">
        <small>Descargar en</small>
        <strong>App Store</strong>
      </span>
    </a>

    <a href={ANDROID_URL} className="store-btn" target="_blank" rel="noopener noreferrer">
      <span className="store-btn-icon"><AndroidIcon /></span>
      <span className="store-btn-text">
        <small>Disponible en</small>
        <strong>Google Play</strong>
      </span>
    </a>
  </div>
);

export default StoreButtons;
